import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useLanguage } from "./context/LanguageContext";

export default function WifiConnectPage() {
  const navigate = useNavigate();
  const { storeId, tableNo } = useParams();
  const [wifiData, setWifiData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [copied, setCopied] = useState(false);
  const { language, setLanguage } = useLanguage();
  const [reviewUrl, setReviewUrl] = useState(null);

  useEffect(() => {
    const fetchWifi = async () => {
      if (!storeId) {
        setLoading(false);
        return;
      }

      try {
        const functionUrl = process.env.REACT_APP_APP_WIFI;
       
        const response = await fetch(functionUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ storeId })
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.message || (language === "en" ? "获取WiFi信息失败" : "Failed to fetch WiFi"));
        }

        if (result.success) {
          setWifiData(result.data);
          setError(null);
     
          if (result.data && result.data.review) {
            let url = result.data.review;
             
            if (url && !url.startsWith('http://') && !url.startsWith('https://')) {
              url = 'https://' + url;
            }
            setReviewUrl(url);
          }
          detectDevice();
        } else {
          setError(result.message);
        }
      } catch (err) {
        setError(err.message || (language === "en" ? "WiFi服务连接失败" : "Failed to connect to WiFi service"));
      } finally {
        setLoading(false);
      }
    };

    fetchWifi();
  }, [storeId, language]);

  const [isMobile, setIsMobile] = useState(false);
  
  const detectDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent)) {
      setIsMobile(true);
    }
  };

  const handleContinue = () => navigate(`/order/${storeId}/${tableNo}`, { replace: true });

  const handleReview = () => {
    if (reviewUrl) {
       
      window.open(reviewUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const toggleLanguage = () => {
    setLanguage(language === "en" ? "cn" : "en");
  };

  const getDeviceInstructions = () => {
    if (/android/i.test(navigator.userAgent)) {
      return language === "en" 
        ? "📱 安卓：打开相机扫描二维码即可自动连接" 
        : "📱 Android: Scan QR code with your camera app to connect automatically";
    } else if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
      return language === "en" 
        ? "📱 苹果：长安这个二维码或者打开相机扫描二维码，然后点击\"加入网络\"" 
        : "📱 iPhone: Long press the QR code or scan the QR code, then tap 'Join Network'";
    } else {
      return language === "en" 
        ? "💻 电脑：请使用下方密码手动连接" 
        : "💻 Desktop: Use the password below to connect manually";
    }
  };

  if (loading) return (
    <div className="customer-welcome">
      <p>{language === "en" ? "正在加载WiFi信息..." : "Loading WiFi information..."}</p>
    </div>
  );

  if (error || !wifiData) {
    return (
      <div className="customer-welcome">
        <p style={{ color: error ? '#c8103e' : '#666' }}>
          {error || (language === "en" ? "暂无WiFi信息" : "No WiFi information available")}
        </p>
        <p>{language === "en" ? "您可以在未连接WiFi的情况下继续点餐" : "You can still continue to order without WiFi"}</p>
        <button 
          onClick={handleContinue}
          style={{
            padding: '10px 20px',
            marginTop: '20px',
            backgroundColor: '#c8103e',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          {language === "en" ? "继续点餐" : "Continue to Order"}
        </button>
      </div>
    );
  }

  const qrText = `WIFI:T:WPA;S:${wifiData.ssid};P:${wifiData.password};;`;

  return (
    <div className="customer-welcome">
    
      <button
        onClick={toggleLanguage}
        style={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          padding: '8px 16px',
          backgroundColor: '#fff5f8',
          border: '1px solid #efdce3',
          borderRadius: '20px',
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: '500',
          color: '#333',
          zIndex: 1000
        }}
      >
        {language === "cn" ? "🇨🇳 中文" : "🇺🇸 English"}
      </button>

      <h2>{language === "en" ? `欢迎使用 ${wifiData.ssid} WIFI` : `Welcome to ${wifiData.ssid} WIFI`}</h2>
      
      <div style={{ 
        backgroundColor: '#fff5f8', 
        padding: '15px', 
        borderRadius: '8px',
        marginBottom: '20px'
      }}>
        <p style={{ margin: 0, fontSize: '14px' }}>
          {getDeviceInstructions()}
        </p>
      </div>
      
      <div style={{ margin: '20px 0' }}>
        <div style={{ 
          backgroundColor: 'white', 
          padding: '20px', 
          borderRadius: '12px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          <img 
            src={`https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=${encodeURIComponent(qrText)}`} 
            alt="WiFi QR Code"
            style={{ 
              width: '250px', 
              height: '250px', 
              margin: '0 auto',
              display: 'block'
            }}
          />
          
          <p style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '15px' }}>
            {wifiData.ssid}
          </p>
        </div>
        
        <button 
          onClick={handleContinue}
          style={{
            padding: '12px 24px',
            backgroundColor: 'crimson',
            color: 'white',
            borderRadius: '5px',
            cursor: 'pointer',
            width: '100%',
            fontSize: '16px',
            marginTop: '10px'
          }}
        >
          {language === "en" ? "去点餐" : "Continue to Order"}
        </button>

        {reviewUrl && (
          <button 
            onClick={handleReview}
            style={{
              padding: '12px 24px',
              backgroundColor: '#c8103e',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              width: '100%',
              fontSize: '16px',
              marginTop: '10px',
              transition: 'background-color 0.3s'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#a80d34'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#c8103e'}
          >
            {language === "en" ? "⭐ 给我们评价" : "⭐ Give us a review"}
          </button>
        )}
      </div>
    </div>
  );
}